<template>
  <div class="tests">
    <header>
      <div class="search">
        <UIcon name="search" />
        <input type="text" v-model="search" placeholder="Поиск по тестам" />
      </div>
    </header>

    <div class="list">
      <button
        type="button"
        class="test-card create"
        @click="isCreateModalOpen = true"
      >
        <feather-icon
          size="35"
          icon="PlusCircleIcon"
          class="icon"
        />
        <div class="title">Добавить тест</div>
      </button>

      <TestCard v-for="test of filteredTests" :key="test.id" :test="test" />
    </div>

    <TestCreateModal
      v-model="isCreateModalOpen"
      :materials="materials"
      :user="user"
      @manual="createManual"
      @generated="openGeneratedTest"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TestCard from '@/components/redesign/tests/TestCard.vue'
import TestCreateModal from '@/components/redesign/tests/TestCreateModal.vue'

export default {
  name: 'Tests',
  components: { TestCard, TestCreateModal },
  data() {
    return {
      search: '',
      isCreateModalOpen: false,
    }
  },
  computed: {
    ...mapState('courses', ['tests', 'materials']),
    ...mapState('main', ['user']),
    filteredTests() {
      const query = this.search.trim().toLocaleLowerCase('ru-RU')
      if (!query) return this.tests

      return this.tests.filter(test => [test.title, test.description]
        .filter(Boolean)
        .some(value => String(value).toLocaleLowerCase('ru-RU').includes(query)))
    },
  },
  methods: {
    ...mapActions('courses', ['getTests', 'getMaterial']),
    createManual() {
      this.isCreateModalOpen = false
      this.$router.push('/test/0')
    },
    openGeneratedTest(draft) {
      sessionStorage.setItem('eddy-test-draft', JSON.stringify(draft))
      this.isCreateModalOpen = false
      this.$router.push('/test/0')
    },
  },
  async mounted() {
    await Promise.all([this.getTests(), this.getMaterial()])
  },
}
</script>

<style lang="scss">
.tests {
  width: 100%;

  header {
    margin-bottom: 24px;

    .search {
      display: flex;
      align-items: center;
      padding: 0 16px;
      height: 48px;
      background: #FFFFFF;
      border-radius: 8px;
      width: 100%;

      .icon {
        fill: #A9A9A9;
        margin-right: 24px;
      }

      input {
        height: 100%;
        padding: 0;
        border: none;
        font-size: 16px;
      }
    }
  }

  .list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 20px;
    grid-row-gap: 20px;

    .test-card {
      width: 100%;
      min-height: 160px;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0px 12px 13px rgba(197, 197, 197, 0.25);
      }

      &.create {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 16px;
        font-weight: 500;
        background: #FFFFFF;
        border: 1px dashed #9CCFE7;
        border-radius: 15px;
        cursor: pointer;

        .title {
          margin-top: 10px;
          color: var(--primary);
        }

        .icon {
          color: var(--primary);
        }
      }
    }
  }

  @media (max-width: 992px) {
    .list {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 640px) {
    .list {
      grid-template-columns: 1fr;
    }
  }
}
</style>
